(function () {
  'use strict';

  function money(cents) {
    if (window.theme && theme.Currency && theme.settings) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return new Intl.NumberFormat(document.documentElement.lang || 'sl-SI', {
      style: 'currency',
      currency: 'EUR'
    }).format(cents / 100);
  }

  function getCart() {
    var url = window.theme && theme.routes ? theme.routes.cart : '/cart.js';
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (response) {
      if (!response.ok) throw new Error('Impossibile caricare il carrello');
      return response.json();
    });
  }

  function postCart(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) return response.json().then(function (data) { throw new Error(data.description || 'Impossibile aggiornare il carrello'); });
      return response.json();
    });
  }

  function syncCart(cart) {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer || !cart) return;
    if (!Array.isArray(cart.items)) {
      getCart().then(syncCart).catch(function () {});
      return;
    }

    drawer.classList.toggle('is-empty', cart.item_count === 0);
    drawer.querySelectorAll('[data-fleur-cart-count]').forEach(function (element) {
      element.textContent = cart.item_count;
    });

    var discountProgress = drawer.querySelector('[data-fleur-discount-progress]');
    if (discountProgress) {
      var eligibleQuantity = cart.items.reduce(function (sum, item) {
        return item.handle === 'protection-de-commande' ? sum : sum + item.quantity;
      }, 0);
      discountProgress.dataset.eligibleCount = eligibleQuantity;
      discountProgress.querySelectorAll('[data-fleur-discount-tier]').forEach(function (tier) {
        var tierQuantity = Number(tier.dataset.fleurDiscountTier || 0);
        var isActive = tierQuantity === Math.min(Math.max(eligibleQuantity, 0), 5);
        tier.classList.toggle('is-active', isActive);
        if (isActive) tier.setAttribute('aria-current', 'step');
        else tier.removeAttribute('aria-current');
      });
      var discountMessage = discountProgress.querySelector('[data-fleur-discount-message]');
      if (discountMessage) {
        if (eligibleQuantity >= 5) discountMessage.textContent = 'Hai sbloccato lo sconto massimo del 30%!';
        else if (eligibleQuantity >= 4) discountMessage.textContent = 'Aggiungi ancora 1 articolo e sblocca lo sconto del 30%';
        else if (eligibleQuantity >= 3) discountMessage.textContent = 'Aggiungi ancora 1 articolo e sblocca lo sconto del 20%';
        else if (eligibleQuantity >= 2) discountMessage.textContent = 'Aggiungi ancora 1 articolo e sblocca lo sconto del 15%';
        else if (eligibleQuantity === 1) discountMessage.textContent = 'Aggiungi ancora 1 articolo e sblocca lo sconto del 10%';
        else discountMessage.textContent = 'Aggiungi 2 articoli e sblocca lo sconto del 10%';
      }
    }

    var shipping = drawer.querySelector('[data-fleur-shipping]');
    if (shipping) {
      var message = shipping.querySelector('[data-fleur-shipping-message]');
      var fill = shipping.querySelector('[data-fleur-shipping-fill]');
      if (message) message.textContent = 'I dettagli di spedizione sono indicati al checkout.';
      if (fill) fill.style.width = '100%';
    }

    var originalTotal = cart.items.reduce(function (sum, item) { return sum + item.original_line_price; }, 0);
    var originalElement = drawer.querySelector('[data-fleur-original-total]');
    if (originalElement) {
      originalElement.textContent = money(originalTotal);
      originalElement.hidden = originalTotal <= cart.total_price;
    }

    var productIds = cart.items.map(function (item) { return String(item.product_id); });
    drawer.querySelectorAll('[data-fleur-upsell-product]').forEach(function (card) {
      card.hidden = productIds.indexOf(card.dataset.fleurUpsellProduct) !== -1;
    });

    var protection = drawer.querySelector('[data-fleur-protection]');
    if (protection) {
      var protectionInCart = productIds.indexOf(protection.dataset.productId) !== -1;
      var toggle = protection.querySelector('[data-fleur-protection-toggle]');
      if (toggle) toggle.setAttribute('aria-checked', protectionInCart ? 'true' : 'false');
    }
  }

  function refreshDrawer(cart) {
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    syncCart(cart);
  }

  function addVariant(button) {
    var variantId = Number(button.dataset.variantId);
    if (!variantId || button.classList.contains('is-loading')) return;
    button.classList.add('is-loading');
    postCart(window.theme && theme.routes ? theme.routes.cartAdd : '/cart/add.js', { items: [{ id: variantId, quantity: 1 }] })
      .then(getCart)
      .then(function (cart) {
        button.classList.remove('is-loading');
        button.classList.add('is-added');
        button.textContent = 'Aggiunto';
        refreshDrawer(cart);
      })
      .catch(function () {
        button.classList.remove('is-loading');
        button.textContent = 'Riprova';
      });
  }

  function changeLine(key, quantity) {
    var url = window.theme && theme.routes ? theme.routes.cartChange : '/cart/change.js';
    return postCart(url, { id: key, quantity: quantity }).then(function (cart) {
      refreshDrawer(cart);
      return cart;
    });
  }

  function toggleProtection(button) {
    var section = button.closest('[data-fleur-protection]');
    if (!section || button.disabled) return;
    button.disabled = true;
    var enabled = button.getAttribute('aria-checked') === 'true';
    var action;
    if (enabled) {
      action = getCart().then(function (cart) {
        var item = cart.items.find(function (line) { return String(line.product_id) === section.dataset.productId; });
        return item ? changeLine(item.key, 0) : cart;
      });
    } else {
      action = postCart(window.theme && theme.routes ? theme.routes.cartAdd : '/cart/add.js', {
        items: [{ id: Number(section.dataset.variantId), quantity: 1 }]
      }).then(getCart).then(function (cart) { refreshDrawer(cart); return cart; });
    }
    action.finally(function () { button.disabled = false; });
  }

  function updateUpsellDots(track) {
    var drawer = track.closest('#CartDrawer');
    var dots = drawer ? drawer.querySelectorAll('.fleur-cart__upsell-dots span') : [];
    if (!dots.length) return;
    var cards = Array.from(track.querySelectorAll('[data-fleur-upsell-product]:not([hidden])'));
    var first = cards[0];
    var index = first && first.offsetWidth ? Math.round(track.scrollLeft / (first.offsetWidth + 10)) : 0;
    var dotIndex = Math.min(dots.length - 1, Math.max(0, Math.floor(index * dots.length / Math.max(cards.length, 1))));
    dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === dotIndex); });
  }

  var quickBuyState = {
    product: null,
    selections: [],
    opener: null,
    closeTimer: null
  };

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function ensureQuickBuy() {
    var existing = document.querySelector('[data-fleur-quickbuy]');
    if (existing) return existing;

    var modal = document.createElement('div');
    modal.className = 'fleur-quickbuy';
    modal.hidden = true;
    modal.setAttribute('data-fleur-quickbuy', '');
    modal.innerHTML =
      '<div class="fleur-quickbuy__panel" role="dialog" aria-modal="true" aria-label="Scegli le opzioni">' +
        '<button type="button" class="fleur-quickbuy__close" data-fleur-quickbuy-close aria-label="Chiudi">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"></path></svg>' +
        '</button>' +
        '<div data-fleur-quickbuy-body><div class="fleur-quickbuy__loading">Caricamento...</div></div>' +
      '</div>';
    document.body.appendChild(modal);

    modal.addEventListener('click', function (event) {
      if (event.target === modal || event.target.closest('[data-fleur-quickbuy-close]')) closeQuickBuy();
    });
    return modal;
  }

  function productOptionName(option, index) {
    if (typeof option === 'string') return option;
    return option && (option.name || option.label) ? option.name || option.label : 'Opzione ' + (index + 1);
  }

  function productOptionValues(product, option, index) {
    if (option && Array.isArray(option.values)) return option.values.map(String);
    var values = [];
    product.variants.forEach(function (variant) {
      var value = variant.options && variant.options[index] != null ? variant.options[index] : variant['option' + (index + 1)];
      value = value == null ? '' : String(value);
      if (values.indexOf(value) === -1) values.push(value);
    });
    return values;
  }

  function variantOption(variant, index) {
    var value = variant.options && variant.options[index] != null ? variant.options[index] : variant['option' + (index + 1)];
    return value == null ? '' : String(value);
  }

  function selectedVariant() {
    var product = quickBuyState.product;
    if (!product) return null;
    if (product.options.length === 1 && productOptionName(product.options[0], 0) === 'Title') {
      return product.variants.find(function (variant) { return variant.available; }) || null;
    }
    if (quickBuyState.selections.some(function (selection) { return !selection; })) return null;
    return product.variants.find(function (variant) {
      return variant.available && quickBuyState.selections.every(function (selection, index) {
        return variantOption(variant, index) === selection;
      });
    }) || null;
  }

  function variantIsCompatible(variant, optionIndex, value) {
    if (!variant.available || variantOption(variant, optionIndex) !== value) return false;
    return quickBuyState.selections.every(function (selection, index) {
      return index === optionIndex || !selection || variantOption(variant, index) === selection;
    });
  }

  function priceHtml(variant) {
    if (!variant) return '';
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      return '<span class="fleur-quickbuy__price fleur-quickbuy__price--sale">' + money(variant.price) + '</span>' +
        '<span class="fleur-quickbuy__compare">' + money(variant.compare_at_price) + '</span>' +
        '<span class="fleur-quickbuy__sale-word">Reducere</span>' +
        '<span class="fleur-quickbuy__sale-label">Saldi estivi</span>';
    }
    return '<span class="fleur-quickbuy__price">' + money(variant.price) + '</span>';
  }

  function updateQuickBuy() {
    var modal = ensureQuickBuy();
    var product = quickBuyState.product;
    if (!product) return;

    modal.querySelectorAll('[data-fleur-option]').forEach(function (button) {
      var optionIndex = Number(button.dataset.optionIndex);
      var value = button.dataset.optionValue;
      var available = product.variants.some(function (variant) {
        return variantIsCompatible(variant, optionIndex, value);
      });
      button.disabled = !available;
      button.classList.toggle('is-selected', quickBuyState.selections[optionIndex] === value);
    });

    var variant = selectedVariant();
    var addButton = modal.querySelector('[data-fleur-quickbuy-add]');
    if (addButton) addButton.disabled = !variant;
    var price = modal.querySelector('[data-fleur-quickbuy-price]');
    if (price && variant) price.innerHTML = priceHtml(variant);
  }

  function renderQuickBuy(product) {
    quickBuyState.product = product;
    quickBuyState.selections = product.options.map(function () { return ''; });

    var variant = product.variants.find(function (item) { return item.available; }) || product.variants[0];
    var image = product.featured_image || (variant && variant.featured_image && variant.featured_image.src) || '';
    if (image.indexOf('//') === 0) image = window.location.protocol + image;
    if (image) image += (image.indexOf('?') === -1 ? '?' : '&') + 'width=340';

    var hasOptions = !(product.options.length === 1 && productOptionName(product.options[0], 0) === 'Title');
    var options = '';
    if (hasOptions) {
      product.options.forEach(function (option, optionIndex) {
        var values = productOptionValues(product, option, optionIndex);
        options += '<div class="fleur-quickbuy__group">' +
          '<div class="fleur-quickbuy__label">' + escapeHtml(productOptionName(option, optionIndex)) + '</div>' +
          '<div class="fleur-quickbuy__values">';
        values.forEach(function (value) {
          options += '<button type="button" class="fleur-quickbuy__option" data-fleur-option data-option-index="' + optionIndex + '" data-option-value="' + escapeHtml(value) + '">' + escapeHtml(value) + '</button>';
        });
        options += '</div></div>';
      });
    }

    var modal = ensureQuickBuy();
    var body = modal.querySelector('[data-fleur-quickbuy-body]');
    body.innerHTML =
      '<div class="fleur-quickbuy__head">' +
        '<div class="fleur-quickbuy__image">' + (image ? '<img src="' + escapeHtml(image) + '" alt="">' : '') + '</div>' +
        '<div class="fleur-quickbuy__meta">' +
          '<div class="fleur-quickbuy__title">' + escapeHtml(product.title) + '</div>' +
          '<div class="fleur-quickbuy__prices" data-fleur-quickbuy-price>' + priceHtml(variant) + '</div>' +
        '</div>' +
      '</div>' +
      '<div class="fleur-quickbuy__options">' + options + '</div>' +
      '<div class="fleur-quickbuy__error" data-fleur-quickbuy-error hidden></div>' +
      '<button type="button" class="fleur-quickbuy__add" data-fleur-quickbuy-add' + (hasOptions ? ' disabled' : '') + '>Aggiungi al carrello</button>';

    body.querySelectorAll('[data-fleur-option]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;
        var optionIndex = Number(button.dataset.optionIndex);
        quickBuyState.selections[optionIndex] = button.dataset.optionValue;
        updateQuickBuy();
      });
    });
    body.querySelector('[data-fleur-quickbuy-add]').addEventListener('click', addQuickBuyVariant);
    updateQuickBuy();
  }

  function openQuickBuy(button) {
    var modal = ensureQuickBuy();
    var body = modal.querySelector('[data-fleur-quickbuy-body]');
    var handle = button.dataset.productHandle;
    if (!handle) return;

    clearTimeout(quickBuyState.closeTimer);
    quickBuyState.product = null;
    quickBuyState.opener = button;
    body.innerHTML = '<div class="fleur-quickbuy__loading">Caricamento...</div>';
    modal.hidden = false;
    document.body.classList.add('fleur-quickbuy-open');
    requestAnimationFrame(function () { modal.classList.add('is-open'); });

    var root = window.theme && theme.routes && (theme.routes.root || theme.routes.home) ? theme.routes.root || theme.routes.home : '/';
    if (root.slice(-1) !== '/') root += '/';
    fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Impossibile caricare il prodotto');
        return response.json();
      })
      .then(renderQuickBuy)
      .catch(function () {
        body.innerHTML = '<div class="fleur-quickbuy__error">Impossibile caricare il prodotto. Riprova.</div>';
      });
  }

  function closeQuickBuy() {
    var modal = document.querySelector('[data-fleur-quickbuy]');
    if (!modal || modal.hidden) return;
    modal.classList.remove('is-open');
    document.body.classList.remove('fleur-quickbuy-open');
    clearTimeout(quickBuyState.closeTimer);
    quickBuyState.closeTimer = setTimeout(function () {
      modal.hidden = true;
      quickBuyState.product = null;
      if (quickBuyState.opener) quickBuyState.opener.focus();
    }, 260);
  }

  function addQuickBuyVariant() {
    var modal = ensureQuickBuy();
    var addButton = modal.querySelector('[data-fleur-quickbuy-add]');
    var error = modal.querySelector('[data-fleur-quickbuy-error]');
    var variant = selectedVariant();
    if (!variant || addButton.disabled) return;

    addButton.disabled = true;
    addButton.textContent = 'Aggiunta in corso...';
    if (error) error.hidden = true;
    var formData = new FormData();
    formData.append('id', variant.id);
    formData.append('quantity', '1');

    fetch(window.theme && theme.routes ? theme.routes.cartAdd : '/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (response) { return response.json(); })
      .then(function (product) {
        if (product.status === 422) throw new Error(product.description || 'Impossibile aggiornare il carrello');
        closeQuickBuy();
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: product, addToCartBtn: addButton }
        }));
      })
      .catch(function (requestError) {
        addButton.disabled = false;
        addButton.textContent = 'Aggiungi al carrello';
        if (error) {
          error.textContent = requestError.message || 'Si è verificato un errore. Riprova.';
          error.hidden = false;
        }
      });
  }

  document.addEventListener('click', function (event) {
    var checkoutButton = event.target.closest('#CartDrawer [name="checkout"]');
    if (checkoutButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (checkoutButton.disabled) return;
      checkoutButton.disabled = true;
      checkoutButton.classList.add('btn--loading');
      window.location.assign('/checkout');
    }
  }, true);

  document.addEventListener('click', function (event) {
    var quickButton = event.target.closest('.fleur-lune-card__quick');
    if (quickButton) {
      event.preventDefault();
      event.stopPropagation();
      openQuickBuy(quickButton);
      return;
    }

    var upsellButton = event.target.closest('[data-fleur-upsell-add]');
    if (upsellButton) {
      event.preventDefault();
      addVariant(upsellButton);
      return;
    }

    var protectionButton = event.target.closest('[data-fleur-protection-toggle]');
    if (protectionButton) {
      event.preventDefault();
      toggleProtection(protectionButton);
      return;
    }

    var removeLink = event.target.closest('#CartDrawer .cart__remove');
    if (removeLink) {
      event.preventDefault();
      var item = removeLink.closest('[data-key]');
      if (item) changeLine(item.dataset.key, 0);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeQuickBuy();
  });

  document.addEventListener('cart:updated', function (event) {
    if (event.detail && event.detail.cart) syncCart(event.detail.cart);
    else getCart().then(syncCart).catch(function () {});
  });
  document.addEventListener('ajaxProduct:added', function () {
    getCart().then(syncCart).catch(function () {});
  });

  function init() {
    getCart().then(syncCart).catch(function () {});
    document.querySelectorAll('[data-fleur-upsell-track]').forEach(function (track) {
      track.addEventListener('scroll', function () { updateUpsellDots(track); }, { passive: true });
      updateUpsellDots(track);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
